<template>
  <div class="bossbanner-box">
    <div class="boss-person-box">
      <!-- @/assets/team/boss.png -->
      <img :src="getImgUrl(leaderImg)" class="person" alt="" />
      <div class="text-box">
        <div class="en-title">{{ "co-founder".toUpperCase() }}</div>
        <div class="cn-title">联合创始人</div>
      </div>
    </div>
    <div class="introduce-box">
      <div
        v-for="(item, index) in leaderList"
        :key="index"
        :class="['introduce-item1', { 'introduce-item2': isSwapped != index }]"
        @click="swapItems(index)"
      >
        <img src="@/assets/team/icon.png" alt="" />
        <div class="text-box">
          <div class="text" v-html="item.content"></div>
          <div class="username-box">
            {{ item.title }}
            <span> / 联合创始人</span>
          </div>
        </div>
      </div>
      <!-- <div
        :class="['introduce-item1', { 'introduce-item2': isSwapped == 1 }]"
        @click="swapItems(2)"
      >
        <img src="@/assets/team/icon.png" alt="" />
        <div class="text-box">
          <div class="text">
            衡水市桃城区第七届政协委员
            <br />
            策划方案的主导者，简单而专注，帮客户赢得市场，拥有丰富的管理经验，曾成功创建多种团体组织，敏锐的市
          </div>
          <div class="username-box">冷建斐 <span> / 联合创始人</span></div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    leaderList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    leaderImg() {
      return this.leaderList.length
        ? this.leaderList[this.isSwapped].thumb
        : "";
    },
  },
  data() {
    return {
      isSwapped: 1, // 控制是否为闫
    };
  },
  mounted() {
    console.log("mounted", this.isSwapped);
    setInterval(() => {
      this.swapItems(this.isSwapped == 1 ? 0 : 1);
    }, 5000);
  },
  methods: {
    swapItems(index) {
      this.isSwapped = index; // 切换状态
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("./index.scss");

.introduce-item1 {
  transition: all 0.5s ease; // 添加过渡效果
}

.introduce-item2 {
  opacity: 0.6;
  margin: 2.5rem 0 0 5.625rem;
  .text {
    color: #ffffff !important;
  }
}
</style>
